import React from 'react';
import PropTypes from 'prop-types';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import PlanningVersionUpgradeResponseLayout from './PlanningVersionUpgradeResponseLayout';


const PlanningVersionUpgradeResponseOverride = buildFacetDesignOverride();

function PlanningVersionUpgradeResponse({
  collection,
  refreshCollection,
}) {
  if (collection.resources().length() === 0) {
    collection.create({ addToCollection: true });
  }

  return (
    <MetaFormInline
      resource={collection.resources().head()}
      layout={PlanningVersionUpgradeResponseLayout}
      LayoutProps={{
        refreshCollection,
      }}
      onSubmitBefore={(resource) => {
        // We want to create a new resource instead of updating the existing one
        const newResource = collection.create({ addToCollection: true, addAtIndex: 0 }).resources().head();
        newResource.attr('response', resource.attr('response'));
        return newResource;
      }}
      noIndividualSubmitButtons
      padding={'none'}
      metaOverrideSet={PlanningVersionUpgradeResponseOverride}
    />
  );
}

PlanningVersionUpgradeResponse.propTypes = {
  collection: PropTypes.object.isRequired,
  refreshCollection: PropTypes.func.isRequired,
};

export default PlanningVersionUpgradeResponse;
